<template>
  <div class="manage-department-title">
    {{ titlename }}
  </div>
</template>

<script>
export default {
  name: 'template-title',
  props: {
    titlename: String
  }
}
</script>
